module.exports = __webpack_public_path__ + "img/blank_lead.861b7f7d.svg";